export type AuthMode = 'cognito' | 'disabled';
export type DataMode = 's3' | 'local';
export type LoginMechanism = 'email' | 'username' | 'phone_number';

function optional(value: string | undefined): string {
  return value?.trim() ?? '';
}

function booleanValue(value: string | undefined, fallback: boolean): boolean {
  if (value === undefined || value.trim() === '') {
    return fallback;
  }
  return ['1', 'true', 'yes', 'on'].includes(value.trim().toLowerCase());
}

const isDevelopment = import.meta.env.DEV;

export const runtimeConfig = {
  appTitle: optional(import.meta.env.VITE_APP_TITLE) || 'Balanced Scorecard',
  companyName: optional(import.meta.env.VITE_COMPANY_NAME) || 'ELVI',

  authMode: (optional(import.meta.env.VITE_AUTH_MODE) ||
    (isDevelopment ? 'disabled' : 'cognito')) as AuthMode,
  dataMode: (optional(import.meta.env.VITE_DATA_MODE) ||
    (isDevelopment ? 'local' : 's3')) as DataMode,

  awsRegion: optional(import.meta.env.VITE_AWS_REGION),
  userPoolId: optional(import.meta.env.VITE_COGNITO_USER_POOL_ID),
  userPoolClientId: optional(import.meta.env.VITE_COGNITO_USER_POOL_CLIENT_ID),
  identityPoolId: optional(import.meta.env.VITE_COGNITO_IDENTITY_POOL_ID),
  loginMechanism: (optional(import.meta.env.VITE_COGNITO_LOGIN_MECHANISM) ||
    'email') as LoginMechanism,
  allowSignUp: booleanValue(import.meta.env.VITE_COGNITO_ALLOW_SIGNUP, false),

  s3Bucket: optional(import.meta.env.VITE_S3_BUCKET),
  s3Region: optional(import.meta.env.VITE_S3_REGION),
  registryKey:
    optional(import.meta.env.VITE_S3_REGISTRY_KEY) || 'bsc/config/kpi_registry.xlsx',
  valuesKey:
    optional(import.meta.env.VITE_S3_VALUES_KEY) || 'bsc/data/kpi_values.xlsx',
};

export function validateRuntimeConfig(): void {
  if (runtimeConfig.authMode === 'cognito') {
    const missing = [
      ['VITE_AWS_REGION', runtimeConfig.awsRegion],
      ['VITE_COGNITO_USER_POOL_ID', runtimeConfig.userPoolId],
      ['VITE_COGNITO_USER_POOL_CLIENT_ID', runtimeConfig.userPoolClientId],
      ['VITE_COGNITO_IDENTITY_POOL_ID', runtimeConfig.identityPoolId],
    ]
      .filter(([, value]) => !value)
      .map(([name]) => name);

    if (missing.length > 0) {
      throw new Error(`Configurazione Cognito incompleta: ${missing.join(', ')}`);
    }
  }

  if (runtimeConfig.dataMode === 's3') {
    const missing = [
      ['VITE_S3_BUCKET', runtimeConfig.s3Bucket],
      ['VITE_S3_REGION', runtimeConfig.s3Region],
      ['VITE_S3_REGISTRY_KEY', runtimeConfig.registryKey],
      ['VITE_S3_VALUES_KEY', runtimeConfig.valuesKey],
    ]
      .filter(([, value]) => !value)
      .map(([name]) => name);

    if (missing.length > 0) {
      throw new Error(`Configurazione S3 incompleta: ${missing.join(', ')}`);
    }
  }

  if (runtimeConfig.dataMode === 's3' && runtimeConfig.authMode !== 'cognito') {
    throw new Error('La lettura S3 privata richiede VITE_AUTH_MODE=cognito.');
  }
}
